// Import Bootstrap JS
import * as bootstrap from 'bootstrap';
// Import Swiper and modules
import Swiper from 'swiper';
import { Navigation, Autoplay, FreeMode, Pagination } from 'swiper/modules';

// Import the generated gallery assets module
import { galleryAssets } from './_gallery_assets.js';

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Set active nav item based on current page or section
function setActiveNavItem() {
    const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
    
    // First, check if we're on a subpage by looking at pathname
    const currentPath = window.location.pathname;
    const isSubpage = !currentPath.endsWith('/') && !currentPath.endsWith('index.html');
    
    if (isSubpage) {
        // For subpages, find the nav item that contains the current path
        navLinks.forEach(link => {
            if (link.getAttribute('href').includes(currentPath)) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    } else {
        // For main page, determine active section based on scroll position
        const scrollPosition = window.scrollY;
        
        // Get all sections that have an ID
        const sections = document.querySelectorAll('section[id]');
        
        // Find the section that's currently in view
        let currentSection = null;
        sections.forEach(section => {
            const sectionTop = section.offsetTop - 100; // Account for header height
            const sectionHeight = section.offsetHeight;
            
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                currentSection = section.getAttribute('id');
            }
        });
        
        // Update active nav item
        if (currentSection) {
            navLinks.forEach(link => {
                const href = link.getAttribute('href');
                if (href.endsWith(`#${currentSection}`)) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            });
        }
    }
}

// Call setActiveNavItem on page load and scroll
document.addEventListener('DOMContentLoaded', setActiveNavItem);
window.addEventListener('scroll', setActiveNavItem);

// Navbar background change on scroll
const navbar = document.querySelector('.navbar');
const whiteLogo = document.querySelector('.header-left .logo'); // Get white logo
const blackLogo = document.querySelector('.header-left .logo-blk'); // Get black logo

window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
        navbar.classList.add('navbar-scrolled');
        whiteLogo.setAttribute('aria-hidden', 'true'); // Hide white logo from screen reader
        blackLogo.removeAttribute('aria-hidden'); // Show black logo to screen reader
    } else {
        navbar.classList.remove('navbar-scrolled');
        whiteLogo.removeAttribute('aria-hidden'); // Show white logo to screen reader
        blackLogo.setAttribute('aria-hidden', 'true'); // Hide black logo from screen reader
    }
});

// Initialize testimonials carousel
// const carouselElement = document.querySelector('.testimonials-carousel'); // Use a variable
// const testimonialsCarousel = new bootstrap.Carousel(carouselElement, {
//     interval: 5000,
//     wrap: true
// });

// Parallax effect for hero section
window.addEventListener('scroll', () => {
    const hero = document.querySelector('.hero');
    if (hero) {
        const scrolled = window.pageYOffset;
        hero.style.backgroundPositionY = -(scrolled * 0.5) + 'px';
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Navbar scroll effect
    const navbar = document.querySelector('.navbar');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    });

    // Handle clicks on nav links for smooth scrolling and closing the mobile navbar
    const navbarNav = document.getElementById('navbarNav');
    if (navbarNav) {
        const navLinks = navbarNav.querySelectorAll('.nav-link');
        navLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                const href = this.getAttribute('href');
                const isAnchorLink = href && href.startsWith('#');

                // Perform smooth scroll for anchor links
                if (isAnchorLink) {
                    e.preventDefault(); 
                    const targetElement = document.querySelector(href);
                    if (targetElement) {
                        targetElement.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }

                // Close the navbar if it's open
                if (navbarNav.classList.contains('show')) {
                    const collapseInstance = bootstrap.Collapse.getInstance(navbarNav);
                    if (collapseInstance) {
                        collapseInstance.hide();
                    }
                }
            });
        });
    } else {
        console.error('Navbar collapse element #navbarNav not found for link click handling.');
    }

    // Navbar overlay effect
    const navbarCollapse = document.getElementById('navbarNav');
    const body = document.body;
    // Find the toggler button and the icons within it
    const navbarToggler = document.querySelector('.navbar-toggler');
    const iconBars = navbarToggler ? navbarToggler.querySelector('.icon-bars') : null;
    const iconClose = navbarToggler ? navbarToggler.querySelector('.icon-close') : null;

    if (navbarCollapse && iconBars && iconClose) {
        navbarCollapse.addEventListener('show.bs.collapse', () => {
            body.classList.add('navbar-overlay-active');
            // Show close icon, hide bars icon
            iconBars.classList.add('d-none');
            iconClose.classList.remove('d-none');
        });

        navbarCollapse.addEventListener('hide.bs.collapse', () => {
            body.classList.remove('navbar-overlay-active');
            // Show bars icon, hide close icon
            iconBars.classList.remove('d-none');
            iconClose.classList.add('d-none');
        });
    } else {
        if (!navbarCollapse) {
            console.error('Navbar collapse element #navbarNav not found.');
        }
        if (!iconBars || !iconClose) {
            console.error('Navbar toggler icons (.icon-bars or .icon-close) not found.');
        }
    }

    // Hero image mouse move effect (Desktop only)
    const heroSection = document.querySelector('.hero');
    const heroImage = document.querySelector('.hero-background-image');
    const DESKTOP_BREAKPOINT = 992;
    const MAX_TRANSLATE = 25; // Max pixels to translate

    heroSection.addEventListener('mousemove', (e) => {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            // Reset transform if resizing below breakpoint
            if (heroImage.style.transform !== 'scale(1.1)') {
                heroImage.style.transform = 'scale(1.1)';
            }
            return; 
        }
        heroImage.classList.add('hover');

        const { left, top, width, height } = heroSection.getBoundingClientRect();
        const mouseX = e.clientX - left; // Mouse X relative to hero section
        const mouseY = e.clientY - top; // Mouse Y relative to hero section

        // Calculate center of the hero section
        const centerX = width / 2;
        const centerY = height / 2;

        // Calculate distance from center (-0.5 to 0.5 range)
        const deltaX = (mouseX - centerX) / width;
        const deltaY = (mouseY - centerY) / height;

        // Calculate translation values
        const translateX = -deltaX * MAX_TRANSLATE * 2; // Multiply by 2 to get full -15 to +15 range
        const translateY = -deltaY * MAX_TRANSLATE * 2;

        // Apply transform (keeping the base scale)
        heroImage.style.transform = `scale(1.1) translateX(${translateX.toFixed(2)}px) translateY(${translateY.toFixed(2)}px)`;
    });

    // Optional: Reset on mouse leave
    heroSection.addEventListener('mouseleave', () => {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) {
            heroImage.style.transform = 'scale(1.1) translateX(0px) translateY(0px)';
        }
        heroImage.classList.remove('hover');
    });

    // Optional: Reset on resize if window becomes smaller than desktop
    window.addEventListener('resize', () => {
            if (window.innerWidth < DESKTOP_BREAKPOINT) {
            heroImage.style.transform = 'scale(1.1)'; // Reset to base scale
            }
    });

    // --- Swiper Gallery Initialization ---
    const galleryMainWrapper = document.querySelector('.projects-main .swiper-wrapper');

    if (galleryMainWrapper) {
        // Loop through images listed in the imported galleryAssets
        galleryAssets.forEach(imageData => {
            const imageAltText = imageData.alt;

            // Get the URLs for different formats - Now using direct string paths
            const avifSrc = imageData.avifUrl;
            const webpSrc = imageData.webpUrl;
            const fallbackSrc = imageData.fallbackUrl;

            // Create main slide with <picture> element
            const mainSlide = document.createElement('div');
            mainSlide.classList.add('swiper-slide');
            mainSlide.innerHTML = `
                <picture>
                    <source srcset="${avifSrc}" type="image/avif">
                    <source srcset="${webpSrc}" type="image/webp">
                    <img src="${fallbackSrc}" alt="${imageAltText}" loading="lazy">
                </picture>
            `;
            galleryMainWrapper.appendChild(mainSlide);
        });

        // Initialize Main Swiper with updated settings (based on former clone)
        const galleryMain = new Swiper(".projects-main", {
            modules: [Navigation, Autoplay, FreeMode, Pagination],
            spaceBetween: 0,
            rewind: true,
            lazyPreloadPrevNext: 2,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            slidesPerView: 1,
            centeredSlides: true,
            initialSlide: 0,
            grabCursor: true,
            speed: 300,
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            a11y: {
                prevSlideMessage: 'Previous image',
                nextSlideMessage: 'Next image',
            },
            // Ensure proper initialization when the gallery comes into view
            observer: true,
            observeParents: true,
            // Only use one breakpoint for larger screens
            breakpoints: {
                // When window width is >= 576px
                // 576: {
                //     slidesPerView: 1,
                // },
                920: {
                    slidesPerView: 1.2,
                },
                992: {
                    slidesPerView: 1.3,
                },
                1050: {
                    slidesPerView: 1.35,
                },
                1200: {
                    slidesPerView: 1.5,
                },
                1400: {
                    slidesPerView: 1.75,
                },
                1600: {
                    slidesPerView: 2.1,
                },
                1800: {
                    slidesPerView: 2.35,
                }
            }
        });
        
        // Reset to first slide when page is refreshed/loaded
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

        galleryMain.slideTo(0, 0);
        // Force autoplay to start
        galleryMain.autoplay.start();

    } else {
        console.error("Swiper projects container (.projects-main) not found!");
    }
    // --- End Swiper Gallery Initialization ---

    // --- Copyright Year Update ---
    const currentYearSpan = document.getElementById('current-year');
    if (currentYearSpan) {
        currentYearSpan.textContent = new Date().getFullYear();
    }
}); 